/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  createWhatsappQrConnection(name, operationId) {
    return axios.post(`${this.baseUrl()}/whatsapp_qr_connections`, {
      name,
      operation_id: operationId,
    });
  }

  getWhatsappQrConnection(connectionId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp_qr_connections/${connectionId}`
    );
  }

  getWhatsappQrConnectionStatus(connectionId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp_qr_connections/${connectionId}/status`
    );
  }

  getWhatsappQrCode(connectionId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp_qr_connections/${connectionId}/qr`
    );
  }

  disconnectWhatsappQrConnection(connectionId) {
    return axios.post(
      `${this.baseUrl()}/whatsapp_qr_connections/${connectionId}/disconnect`
    );
  }
}

export default new Inboxes();
